/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionPlanDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCommissionPlanDto, serializeDeleteCommissionPlanRequest, serializeUpdateCommissionPlanRequest, type CommissionPlanDto, type DeleteCommissionPlanRequest, type ErrorResponse, type InternalErrorResponse, type UpdateCommissionPlanRequest } from '../../../../models/index.js';
// @ts-ignore
import { ActivateRequestBuilderRequestsMetadata, type ActivateRequestBuilder } from './activate/index.js';
// @ts-ignore
import { DeactivateRequestBuilderRequestsMetadata, type DeactivateRequestBuilder } from './deactivate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans/{commissionPlanId}
 */
export interface WithCommissionPlanItemRequestBuilder extends BaseRequestBuilder<WithCommissionPlanItemRequestBuilder> {
    /**
     * The activate property
     */
    get activate(): ActivateRequestBuilder;
    /**
     * The deactivate property
     */
    get deactivate(): DeactivateRequestBuilder;
    /**
     * Removes the plan permanently. This is not the reversible deactivation the plans deactivate endpoint performs, and it is not the reversible deletion statements get — nothing here brings a deleted plan back, so prefer deactivating a plan you may want again. Statements already generated survive and keep the amounts they were calculated with, but the plan they name will no longer resolve.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns the plan whether or not it is currently active, with its full set of rules and customer overrides. To find the plan a statement would actually be generated against, use the active-plan endpoint instead — this one does not check the effective dates or the active flag. A plan belonging to another organization reads as not found.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionPlanDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCommissionPlanItemRequestBuilderGetQueryParameters> | undefined) : Promise<CommissionPlanDto | undefined>;
    /**
     * Changes the name, description, default rate and effective dates, and nothing else. This is a replacement rather than a patch: the description, the default rate and both effective dates are written exactly as sent, so omitting one clears it — an omitted default rate becomes 0%, and omitted effective dates become open-ended. Send the values you want to keep alongside the ones you are changing. The name is the single exception: leave it blank and the current name stays. Rules and customer overrides cannot be edited or removed through this API at all, by this endpoint or any other — to change them, create a replacement plan with the rules you want and deactivate this one, which leaves statements already generated from it untouched. Renaming does not change the plan's identifier. Rates are fractions between 0 and 1, and a start date after the end date is rejected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionPlanDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionPlanDto | undefined>;
    /**
     * Removes the plan permanently. This is not the reversible deactivation the plans deactivate endpoint performs, and it is not the reversible deletion statements get — nothing here brings a deleted plan back, so prefer deactivating a plan you may want again. Statements already generated survive and keep the amounts they were calculated with, but the plan they name will no longer resolve.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns the plan whether or not it is currently active, with its full set of rules and customer overrides. To find the plan a statement would actually be generated against, use the active-plan endpoint instead — this one does not check the effective dates or the active flag. A plan belonging to another organization reads as not found.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCommissionPlanItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Changes the name, description, default rate and effective dates, and nothing else. This is a replacement rather than a patch: the description, the default rate and both effective dates are written exactly as sent, so omitting one clears it — an omitted default rate becomes 0%, and omitted effective dates become open-ended. Send the values you want to keep alongside the ones you are changing. The name is the single exception: leave it blank and the current name stays. Rules and customer overrides cannot be edited or removed through this API at all, by this endpoint or any other — to change them, create a replacement plan with the rules you want and deactivate this one, which leaves statements already generated from it untouched. Renaming does not change the plan's identifier. Rates are fractions between 0 and 1, and a start date after the end date is rejected.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns the plan whether or not it is currently active, with its full set of rules and customer overrides. To find the plan a statement would actually be generated against, use the active-plan endpoint instead — this one does not check the effective dates or the active flag. A plan belonging to another organization reads as not found.
 */
export interface WithCommissionPlanItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithCommissionPlanItemRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans/{commissionPlanId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCommissionPlanItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCommissionPlanItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    activate: {
        requestsMetadata: ActivateRequestBuilderRequestsMetadata,
    },
    deactivate: {
        requestsMetadata: DeactivateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCommissionPlanItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCommissionPlanItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteCommissionPlanRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithCommissionPlanItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionPlanDtoFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithCommissionPlanItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionPlanDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateCommissionPlanRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
